import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { CourseList } from "@/features/training/components/course-list"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function HelloAISecurityPage() {
  const { t } = useTranslation("", { keyPrefix: "training.risk.content" })

  const dataControlBullets = t("full_data_control_bullet_points", {
    returnObjects: true,
  }) as string[]

  const loginSecurityBullets = t("login_security_bullet_points", {
    returnObjects: true,
  }) as string[]
  const monitoringBullets = t("monitoring_and_limiting_bullet_points", {
    returnObjects: true,
  }) as string[]
  const responsibleAiBullets = t("responsible_ai_principles_bullet_points", {
    returnObjects: true,
  }) as string[]

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("main_title")}</h2>
        <p>{parse(t("intro_paragraph"))}</p>
      </CourseSection>

      <CourseSection>
        <h3>{t("full_data_control_title")}</h3>
        <p>{parse(t("full_data_control_paragraph"))}</p>
        <CourseList data={dataControlBullets} />
        <img
          alt="Description"
          className="bg-secondary dark:bg-background h-auto w-full rounded-[30px]"
          src="/assets/training_images/hello-ai/diagram.png"
        />
      </CourseSection>

      <CourseSection>
        <h3>{t("login_security_title")}</h3>
        <p>{parse(t("login_security_paragraph"))}</p>
        <CourseList data={loginSecurityBullets} />
        <img
          alt="Description"
          className="shadow-x bg-background h-auto w-full rounded-lg border"
          src="/assets/training_images/hello-ai/diagram-2_en.png"
        />
        <p>{parse(t("login_security_conclusion"))}</p>
      </CourseSection>

      <CourseSection>
        <h3>{t("monitoring_and_limiting_title")}</h3>
        <p>{parse(t("monitoring_and_limiting_paragraph"))}</p>
        <CourseList data={monitoringBullets} />
      </CourseSection>

      <CourseSection>
        <h3>{t("responsible_ai_principles_title")}</h3>
        <p>{parse(t("responsible_ai_principles_paragraph"))}</p>
        <CourseList data={responsibleAiBullets} />
      </CourseSection>
    </CourseLayout>
  )
}
